import request from "@/utils/request";

export default function agentEditChargeTimeConf(data) {
    return request({
        url: `/device/chargeTimeConf/agentEditGroupTimeConf`,
        method: 'post',
        data
    })
}
